(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class UspBar extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.usp-bar__item')];
      if (this.items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.index = 0;
      this.timer = setInterval(() => this.next(), 4000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    next() {
      if (window.matchMedia('(min-width: 750px)').matches) return;
      this.items[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].classList.add('is-active');
    }
  }
  customElements.define('usp-bar', UspBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-cart-open]');
        if (opener) {
          event.preventDefault();
          this.open(opener);
        }
        if (event.target.closest('[data-cart-close]') || event.target === this.dialog) this.close();
      });
      document.addEventListener('submit', (event) => {
        const form = event.target.closest('form[data-cart-add], form.product__form');
        if (form) {
          event.preventDefault();
          this.add(form, event.submitter);
        }
      });
      // Cart page (/cart): same limits, the form posts the corrected value.
      document.addEventListener('change', (event) => {
        const input = event.target.closest('.cart-page [data-line-quantity]');
        if (!input) return;
        let quantity = Math.max(0, Math.floor(Number(input.value) || 0));
        if (input.max !== '') quantity = Math.min(quantity, Number(input.max));
        input.value = quantity;
      });
      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-line-quantity]');
        if (!input) return;
        // Never ask for more than the stock (max) or less than 0.
        let quantity = Math.max(0, Math.floor(Number(input.value) || 0));
        if (input.max !== '') quantity = Math.min(quantity, Number(input.max));
        input.value = quantity;
        this.update(input.dataset.lineKey, quantity);
      });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-line-remove]');
        if (button) {
          event.preventDefault();
          this.update(button.dataset.lineKey, 0);
        }
      });
    }

    open(opener) {
      this.opener = opener || document.activeElement;
      if (!this.dialog.open) {
        this.dialog.showModal();
        // Start on the drawer itself, not the close button, so no focus ring shows on a tap.
        this.dialog.querySelector('.drawer__inner')?.focus({ preventScroll: true });
      }
      this.loadComplementary();
    }

    async loadComplementary() {
      const slot = this.querySelector('[data-upsell-slot]');
      if (!slot || slot.dataset.loaded || !slot.dataset.productId) return;
      slot.dataset.loaded = 'true';
      const params = new URLSearchParams({
        product_id: slot.dataset.productId,
        limit: '8',
        intent: 'complementary',
        section_id: 'cart-upsell',
      });
      try {
        const response = await fetch(`${this.root()}recommendations/products?${params}`);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const list = doc.querySelector('[data-upsell]');
        if (!list || !list.querySelector('li')) return;
        this.querySelector('[data-upsell][data-upsell-source="collection"]')?.remove();
        slot.replaceChildren(list);
      } catch (error) {
        // Keep the collection-based upsell.
      }
    }

    close() {
      if (this.dialog.open) this.dialog.close();
      this.opener?.focus?.();
    }

    async add(form, submitter) {
      submitter?.setAttribute('aria-busy', 'true');
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      try {
        const response = await fetch(`${this.root()}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        const data = await response.json();
        if (!response.ok) {
          // Not (all) added, usually because the stock is already in the cart. Show the real cart and why.
          await this.refresh();
          this.open(submitter);
          this.showDrawerError(data.description || data.message);
          return;
        }
        this.render(data.sections);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { form } }));
        // "Afrekenen met in3": straight to checkout, where the buyer picks in3.
        if (submitter?.hasAttribute('data-checkout')) {
          window.location.href = `${this.root()}checkout`;
          return;
        }
        this.open(submitter);
      } catch (error) {
        this.showError(form, error.message);
      } finally {
        submitter?.removeAttribute('aria-busy');
      }
    }

    async update(key, quantity) {
      this.querySelector('.drawer__inner')?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${this.root()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'] }),
        });
        const data = await response.json();
        if (!response.ok) {
          // Refused (more than the stock): show the quantities the cart really has.
          await this.refresh();
          this.showDrawerError(data.description || data.message);
          return;
        }
        if (data.sections) this.render(data.sections);
      } finally {
        this.querySelector('.drawer__inner')?.removeAttribute('aria-busy');
      }
    }

    async refresh() {
      try {
        const response = await fetch(`${this.root()}?sections=cart-drawer`);
        if (response.ok) this.render(await response.json());
      } catch (error) {
        // Keep the current drawer.
      }
    }

    showDrawerError(message) {
      const box = this.querySelector('[data-cart-drawer-error]');
      if (!box || !message) return;
      box.textContent = message;
      box.hidden = false;
    }

    render(sections) {
      const html = sections?.['cart-drawer'];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('#cart-drawer-content');
      if (next) this.querySelector('#cart-drawer-content').replaceWith(next);
      if (this.dialog.open) this.loadComplementary();
      const count = doc.querySelectorAll('[data-line-key][data-line-quantity]');
      let total = 0;
      count.forEach((input) => (total += Number(input.value)));
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = total;
        badge.hidden = total === 0;
      });
      document.querySelectorAll('[data-cart-total]').forEach((label) => {
        label.textContent = next?.dataset.total || '';
        label.hidden = total === 0;
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: total } }));
    }

    showError(form, message) {
      let box = form.querySelector('[data-cart-error]');
      if (!box) {
        box = document.createElement('p');
        box.className = 'form-message form-message--error';
        box.setAttribute('data-cart-error', '');
        box.setAttribute('role', 'alert');
        form.append(box);
      }
      box.textContent = message;
    }

    root() {
      return window.Shopify?.routes?.root || '/';
    }
  }
  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choice-steps"] && !Shopify.designMode) return;
  try {
    
  // A link to #anchor opens that choice, so other pages can point straight at a situation.
  const openChoiceFromHash = () => {
    const id = decodeURIComponent(location.hash.slice(1));
    const choice = id ? document.getElementById(id) : null;
    if (choice?.classList.contains('choice-steps__choice')) {
      choice.open = true;
      choice.scrollIntoView({ block: 'start' });
    }
  };
  window.addEventListener('hashchange', openChoiceFromHash);
  document.addEventListener('DOMContentLoaded', openChoiceFromHash);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["conditions"] && !Shopify.designMode) return;
  try {
    
  // Conditions page: the buttons show one condition at a time on a phone; a link to #nieuw,
  // #retourdeal, #refurbished or #gebruikt opens that one.
  const initConditions = (root) => {
    const tabs = [...root.querySelectorAll('[data-condition-tab]')];
    const show = (key, focus) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.conditionTab === key;
        tab.setAttribute('aria-selected', active);
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      root.querySelectorAll('[data-condition-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.id === key);
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => show(tab.dataset.conditionTab));
      tab.addEventListener('keydown', (event) => {
        const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
        if (!step) return;
        event.preventDefault();
        show(tabs[(index + step + tabs.length) % tabs.length].dataset.conditionTab, true);
      });
    });
    const fromHash = () => {
      const key = decodeURIComponent(location.hash.slice(1));
      if (!tabs.some((tab) => tab.dataset.conditionTab === key)) return false;
      show(key);
      document.getElementById(key)?.scrollIntoView({ block: 'start' });
      return true;
    };
    if (!fromHash()) show(tabs[0]?.dataset.conditionTab);
    window.addEventListener('hashchange', fromHash);
    root.classList.add('is-ready');
  };
  document.querySelectorAll('[data-conditions]').forEach(initConditions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-faq-search]');
    if (!input) return;
    const root = input.closest('.faq');
    const query = input.value.trim().toLowerCase();
    let shown = 0;
    root.querySelectorAll('.faq__item').forEach((item) => {
      const match = !query || item.textContent.toLowerCase().includes(query);
      item.hidden = !match;
      if (match) shown += 1;
      if (query && match) item.open = true;
    });
    root.querySelectorAll('.faq__category').forEach((heading) => {
      heading.hidden = Boolean(query);
    });
    root.querySelector('[data-faq-empty]').hidden = shown > 0;
    root.querySelectorAll('[data-faq-chip]').forEach((chip) => {
      const all = chip.dataset.faqChip === '';
      chip.classList.toggle('pills__pill--active', all);
      chip.toggleAttribute('aria-current', all);
    });
  });

  // A topic chip shows only the questions under that topic; "Alle" shows everything again.
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-faq-chip]');
    if (!chip) return;
    event.preventDefault();
    const root = chip.closest('.faq');
    const topic = chip.dataset.faqChip;
    root.querySelectorAll('[data-faq-chip]').forEach((other) => {
      const active = other === chip;
      other.classList.toggle('pills__pill--active', active);
      other.toggleAttribute('aria-current', active);
    });
    const search = root.querySelector('[data-faq-search]');
    if (search) search.value = '';
    const empty = root.querySelector('[data-faq-empty]');
    if (empty) empty.hidden = true;
    let current = '';
    root.querySelectorAll('.faq__list > *').forEach((node) => {
      if (node.classList.contains('faq__category')) current = node.id;
      node.hidden = Boolean(topic) && current !== topic;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const sync = () => {
      document.querySelectorAll('.footer__col').forEach((col) => {
        col.open = !mobile.matches;
      });
    };
    sync();
    mobile.addEventListener('change', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Search from the bottom bar or the header button (compact product page): open and focus the header search.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-focus-search]');
    const input = document.getElementById('header-search');
    if (!link || !input) return;
    event.preventDefault();
    // The compact product page hides the search bar on a phone; open it first.
    input.closest('.header')?.classList.add('is-search-open');
    input.scrollIntoView({ block: 'center' });
    input.focus();
  });

  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.desktop = window.matchMedia('(min-width: 1100px)');

      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-menu-open]');
        if (!opener) return;
        this.opener = opener;
        this.open();
      });
      this.querySelectorAll('[role="tab"]').forEach((tab) => tab.addEventListener('click', () => this.selectTab(tab)));
      this.addEventListener(
        'toggle',
        (event) => {
          if (event.target.open && this.desktop.matches) this.loadFeatured(event.target);
        },
        true
      );
      this.querySelector('[data-menu-close]')?.addEventListener('click', () => this.close());
      this.dialog.addEventListener('close', () => this.opener?.setAttribute('aria-expanded', 'false'));
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      document.addEventListener('click', (event) => {
        if (this.desktop.matches && !this.contains(event.target)) this.closePanels();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.desktop.matches) this.closePanels(true);
      });
      this.desktop.addEventListener('change', () => {
        this.close();
        this.closePanels();
      });
    }

    open() {
      if (this.desktop.matches) return;
      this.dialog.showModal();
      this.opener?.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    selectTab(tab) {
      this.querySelectorAll('[role="tab"]').forEach((other) => {
        const selected = other === tab;
        other.setAttribute('aria-selected', String(selected));
        const panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
    }

    async loadFeatured(details) {
      const slot = details.querySelector('[data-featured-url]');
      if (!slot || slot.dataset.loaded) return;
      slot.dataset.loaded = 'true';
      try {
        const response = await fetch(`${slot.dataset.featuredUrl}?sort_by=created-descending&section_id=menu-featured`);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-menu-featured]');
        if (content && content.querySelector('a')) slot.replaceChildren(...content.children);
      } catch (error) {
        // The menu works without the featured products.
      }
    }

    closePanels(restoreFocus = false) {
      this.querySelectorAll('details[open]').forEach((details) => {
        details.open = false;
        if (restoreFocus) details.querySelector('summary')?.focus();
      });
    }
  }
  customElements.define('header-menu', HeaderMenu);

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.predictive-search');
      this.timer = null;
      this.controller = null;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(), 200);
      });
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.hide();
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.results.querySelector('a')?.focus();
        }
      });
      this.results.addEventListener('keydown', (event) => this.onResultsKey(event));
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.hide();
      });
    }

    async search() {
      const query = this.input.value.trim();
      if (query.length < 2) return this.hide();
      this.controller?.abort();
      this.controller = new AbortController();
      const params = new URLSearchParams({
        q: query,
        section_id: 'predictive-search',
        'resources[type]': 'product,collection,query',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
      });
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest?${params}`, {
          signal: this.controller.signal,
        });
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('#predictive-search-content');
        if (!content) return this.hide();
        this.results.replaceChildren(content);
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') this.hide();
      }
    }

    onResultsKey(event) {
      const links = [...this.results.querySelectorAll('a')];
      const index = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        links[Math.min(index + 1, links.length - 1)]?.focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (index <= 0) this.input.focus();
        else links[index - 1].focus();
      } else if (event.key === 'Escape') {
        this.hide();
        this.input.focus();
      }
    }

    hide() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
  }
  customElements.define('predictive-search', PredictiveSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const form = event.target.closest('form[data-cart-page]');
    if (form && event.target.matches('[data-line-quantity]')) form.querySelector('.cart-page__update')?.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class LoadMore extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-load-more]');
        if (!link) return;
        event.preventDefault();
        this.load(link);
      });
    }

    async load(link) {
      link.setAttribute('aria-busy', 'true');
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('section_id', this.dataset.section);
      try {
        const response = await fetch(url);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = this.closest('[id^="results-"]');
        const target = results.querySelector('[data-grid-available]');
        const incoming = doc.querySelector('[data-grid-available]');
        if (target && incoming) target.append(...incoming.children);
        const next = doc.querySelector('load-more');
        if (next) this.replaceWith(next);
        else this.remove();
      } catch (error) {
        window.location.href = link.href;
      }
    }
  }
  customElements.define('load-more', LoadMore);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  class ListCollections extends HTMLElement {
    connectedCallback() {
      this.openFromHash = this.openFromHash.bind(this);
      this.openFromHash();
      window.addEventListener('hashchange', this.openFromHash);
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.openFromHash);
    }

    openFromHash() {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;
      const group = this.querySelector(`details[id="${CSS.escape(id)}"]`);
      if (!group) return;
      group.open = true;
      group.scrollIntoView({ block: 'start' });
    }
  }
  customElements.define('list-collections', ListCollections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    // A buy box taller than the screen sticks with its bottom edge instead, so nothing stays out of reach.
    const info = document.querySelector('.product__info');
    if (!info || !('ResizeObserver' in window)) return;
    const place = () => {
      const gap = 16;
      const fits = info.offsetHeight + gap * 2 <= window.innerHeight;
      info.style.setProperty('--info-top', fits ? '' : `${window.innerHeight - info.offsetHeight - gap}px`);
      if (fits) info.style.removeProperty('--info-top');
    };
    new ResizeObserver(place).observe(info);
    window.addEventListener('resize', place);
  })();

  (() => {
    const bar = document.querySelector('[data-sticky-buy]');
    const sentinel = document.querySelector('[data-buy-sentinel]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;
    // Show the bar only once the main buy button has scrolled up out of view, not while it is
    // still below (on load the bar would cover the condition block).
    new IntersectionObserver(([entry]) => {
      const sticky = document.querySelector('[data-sticky-buy]');
      if (sticky) sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(sentinel);
  })();

  (() => {
    const loadSlot = async (slot, url, selector) => {
      if (!slot || slot.dataset.loaded) return;
      slot.dataset.loaded = 'true';
      try {
        const response = await fetch(url);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector(selector);
        if (content && content.querySelector('li')) slot.replaceChildren(content);
      } catch (error) {
        // Optional content: the page works without it.
      }
    };
    const loadAll = () => {
      document.querySelectorAll('[data-addons]').forEach((slot) => loadSlot(slot, slot.dataset.addons, '[data-upsell]'));
    };
    loadAll();
    document.addEventListener('pdp:updated', loadAll);

    // The bar at the bottom follows the chosen quantity: "6 stuks · € 34,20", with the staffel discount
    // of the highest tier reached, rounded to the cent per piece like the tiers above.
    const updateStickyPrice = (qty) => {
      const price = document.querySelector('[data-sticky-price]');
      if (!price) return;
      const unit = Number(price.dataset.unit);
      let pct = 0;
      try {
        (JSON.parse(price.dataset.tiers || 'null') || []).forEach((tier) => {
          if (qty >= Number(tier.min)) pct = Math.max(pct, Number(tier.pct));
        });
      } catch (error) {}
      const piece = Math.round((unit * (100 - pct)) / 100);
      const money = new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency: price.dataset.currency || 'EUR' });
      price.textContent = qty > 1
        ? price.dataset.piecesTotal.replace('[count]', qty).replace('[price]', money.format((piece * qty) / 100))
        : money.format(unit / 100);
    };

    document.addEventListener('click', (event) => {
      const tier = event.target.closest('.staffel__tier');
      if (!tier) return;
      const form = document.querySelector('.product__form');
      const input = form?.querySelector('[data-quantity]');
      if (input) input.value = tier.dataset.qty;
      tier.closest('[data-staffel]').querySelectorAll('.staffel__tier').forEach((button) => button.setAttribute('aria-pressed', String(button === tier)));
      updateStickyPrice(Number(tier.dataset.qty));
    });
    // Keep the quantity between 1 and the stock that is not yet in the cart.
    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-quantity]');
      if (!input) return;
      let qty = Math.max(1, Math.floor(Number(input.value) || 1));
      if (input.max !== '') qty = Math.min(qty, Math.max(1, Number(input.max)));
      input.value = qty;
      updateStickyPrice(qty);
    });
    document.addEventListener('cart:added', (event) => {
      const input = event.detail?.form?.querySelector('[data-quantity]');
      if (!input || input.max === '') return;
      input.max = Math.max(0, Number(input.max) - Number(input.value));
      input.value = 1;
      updateStickyPrice(1);
    });
    document.addEventListener('input', (event) => {
      if (!event.target.matches('[data-quantity]')) return;
      const qty = Number(event.target.value);
      if (qty >= 1) updateStickyPrice(Math.floor(qty));
      document.querySelectorAll('.staffel__tier').forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.qty) === qty)));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
  class NewArrivals extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(tab);
      });
    }

    async select(tab) {
      this.querySelectorAll('[role="tab"]').forEach((other) => {
        const active = other === tab;
        other.setAttribute('aria-selected', String(active));
        other.classList.toggle('pills__pill--active', active);
      });
      const grid = this.querySelector('[data-arrivals-grid]');
      const all = this.closest('section')?.querySelector('[data-arrivals-all]');
      if (all) all.href = `${tab.dataset.url}?sort_by=created-descending`;
      grid.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${tab.dataset.url}?sort_by=created-descending&section_id=${this.dataset.section}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = doc.querySelectorAll('[data-fragment-grid] > li');
        if (items.length) grid.replaceChildren(...items);
      } finally {
        grid.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('new-arrivals', NewArrivals);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('[data-recommendations-content]');
      if (content && !content.hasAttribute('data-recommendations-fallback')) return;
      if (this.hasAttribute('data-eager') || !('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '600px 0px' }
      );
      this.observer.observe(this);
    }

    async load() {
      const response = await fetch(this.dataset.url);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-recommendations-content]');
      if (!content || !content.querySelector('li')) return;
      // Keep our own row when Shopify has only a few recommendations (new store, unique items).
      const shown = this.querySelectorAll('[data-recommendations-fallback] li').length;
      const incoming = content.querySelectorAll('li').length;
      if (shown > incoming && incoming < 4) return;
      const title = content.querySelector('h2');
      if (title && this.dataset.heading) title.textContent = this.dataset.heading;
      this.replaceChildren(content);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  // Reviews page: star filter and "Meer reviews" over the reviews rendered in the page.
  const updateReviews = (root) => {
    const size = Number(root.dataset.pageSize) || 12;
    const filter = root.dataset.filter || '';
    const limit = Number(root.dataset.limit) || size;
    let matching = 0;
    root.querySelectorAll('.reviews__item').forEach((item) => {
      const match = !filter || item.dataset.rating === filter;
      if (match) matching += 1;
      item.hidden = !match || matching > limit;
    });
    const more = root.querySelector('[data-reviews-more]');
    if (more) more.hidden = matching <= limit;
  };

  document.addEventListener('click', (event) => {
    const filter = event.target.closest('[data-reviews-filter]');
    const more = event.target.closest('[data-reviews-more]');
    const root = (filter || more)?.closest('[data-reviews]');
    if (!root) return;
    const size = Number(root.dataset.pageSize) || 12;
    if (filter) {
      root.dataset.filter = filter.dataset.reviewsFilter;
      root.dataset.limit = size;
      root.querySelectorAll('[data-reviews-filter]').forEach((chip) => {
        const active = chip === filter;
        chip.classList.toggle('pills__pill--active', active);
        chip.setAttribute('aria-pressed', active);
      });
    } else {
      root.dataset.limit = (Number(root.dataset.limit) || size) + size;
    }
    updateReviews(root);
  });

  } catch(e) { console.error(e); }
})();
})();
